import { graphql, useStaticQuery } from "gatsby";

interface UseSiteMetadata {
    siteMetadata: {
        title: string,
        description: string,
        twitterUsername: string,
        defaultImage: string,
        siteUrl: string,
    },
    buildTime: string,
}

export const useSiteMetadata = (): UseSiteMetadata => {
    const data = useStaticQuery(graphql`
    query {
      site {
        buildTime(formatString: "YYYY-MM-DD")
        siteMetadata {
          title
          description
          twitterUsername
          defaultImage
          siteUrl
        }
      }
    }
  `)
    return data.site;
}